import { createSvgIcon } from "@mui/material";

export const SchoolIcon = createSvgIcon( 
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="46 58 192 152" fill="currentColor">
        <path d="M227.94,112.35l-0.01-0.01v-0.09h-0.16l-91.16-49.82l-88.32,49.49l32.25,18.4v50l57.34,29.88l57.29-30.31
            v-49.65l17.76-9.7v58.19h15v-66.38L227.94,112.35z M136.73,85.29l49.5,27.06l-49.49,27.04l-47.83-27.3L136.73,85.29z M180.16,170.87
            l-42.35,22.4l-42.28-22.04v-32.35l41,23.4l43.63-23.84V170.87z"/>
    </svg>,
    'SchoolIcon'
)
